import { useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
    { href: "#story", label: "Our Story", testid: "nav-story-link" },
    { href: "#kitchens", label: "Kitchens", testid: "nav-kitchens-link" },
    { href: "#esak", label: "Esak", testid: "nav-esak-link" },
    { href: "#menu", label: "Menu", testid: "nav-menu-link" },
    { href: "#gallery", label: "Gallery", testid: "nav-gallery-link" },
    { href: "/pets", label: "Pets", testid: "nav-pets-link", route: true },
    { href: "#visit", label: "Visit Us", testid: "nav-visit-link" },
];

const resolveHref = (l) => (l.route || window.location.pathname === "/" ? l.href : `/${l.href}`);

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const onHome = window.location.pathname === "/";

    return (
        <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#FFF7C5]/85 border-b border-[#262055]/10" data-testid="site-navbar">
            <nav className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-[1fr_auto_1fr] items-center px-6 md:px-10 h-20">
                <a href="/" className="justify-self-start" data-testid="nav-logo-link">
                    <img src="/brand/ua-logo-colour.webp" alt="Uncover Avenue" className="h-12 w-auto" />
                </a>

                <div className="hidden md:flex items-center gap-9 justify-self-center">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={resolveHref(l)}
                            data-testid={l.testid}
                            className="text-sm font-medium tracking-wide text-[#262055]/75 hover:text-[#00958C] transition-colors duration-200"
                        >
                            {l.label}
                        </a>
                    ))}
                </div>

                <div className="justify-self-end flex items-center gap-3">
                    <a
                        href={onHome ? "#reserve" : "/#reserve"}
                        data-testid="nav-reserve-button"
                        className="hidden md:inline-block rounded-full bg-[#F0841B] text-white text-sm font-semibold px-7 py-3 shadow-lg shadow-[#F0841B]/30 hover:brightness-110 hover:-translate-y-0.5 transition-[transform,filter] duration-200"
                    >
                        Reserve a Table
                    </a>
                    <button
                        className="md:hidden text-[#262055] p-2"
                        onClick={() => setOpen(!open)}
                        aria-label="Toggle menu"
                        data-testid="nav-mobile-toggle"
                    >
                        {open ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </nav>

            {open && (
                <div className="md:hidden px-6 pb-6 flex flex-col gap-4 bg-[#FFF7C5]/95 backdrop-blur-xl" data-testid="nav-mobile-menu">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={resolveHref(l)}
                            onClick={() => setOpen(false)}
                            data-testid={`${l.testid}-mobile`}
                            className="text-base font-medium text-[#262055]"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href={onHome ? "#reserve" : "/#reserve"}
                        onClick={() => setOpen(false)}
                        data-testid="nav-reserve-button-mobile"
                        className="rounded-full bg-[#F0841B] text-white text-center text-sm font-semibold px-7 py-3"
                    >
                        Reserve a Table
                    </a>
                </div>
            )}
        </header>
    );
};
